<app-label-inflator
  #labelCalculator
  hidden
  class="label-calculator"
  [calculateVirtualLabel]="true"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>
<div class="content-area">
  <div class="content">
    <div
      class="card-header"
      [style.border-color]="viewModel.topOfCardBackgroundColor$ | async"
      [style.background-color]="viewModel.topOfCardBackgroundColor$ | async"
      [style.color]="viewModel.topOfCardTextColor$ | async">
      <ng-container *ngIf="data | method: 'rowVariantType' | trimSafely as variantType">
        {{ variantType }}
      </ng-container>
    </div>
    <div class="card-identification-area">
      <div class="background-content" [style.background-color]="viewModel.cardColor$ | async">
        <app-print-card-background-image-with-color-overlay-and-opacity [cardBackground]="data">
        </app-print-card-background-image-with-color-overlay-and-opacity>
      </div>
      <div class="id-info">
        <div class="split-logo">
          <div class="left-side">
            <div
              *ngIf="viewModel.strainSymbol$ | async"
              class="strain"
              [style.background-color]="viewModel.strainDeterminedBackgroundColor$ | async">
              {{ viewModel.strainSymbol$ | async }}
            </div>
            <div class="title-brand-label-top-terpene">
              <div class="title-brand-label">
                <!-- titleContainer is used in the shared abstract class, so don't remove -->
                <div
                  #titleContainer
                  appPrintCardScaleDownText
                  class="product-title"
                  [transparentWhileScaling]="true"
                  [maxHeightInPx]="48"
                  [style.color]="viewModel.bodyTextColor$ | async">
                  {{ data | method: 'getRowTitle' }}
                  @if (viewModel.hasBadgesInlineWithName$ | async) {
                    <span class="line-badges">
                      @for (variantBadge of viewModel.badgesInlineWithName$ | async; track variantBadge.id) {
                        <img
                          appImage
                          class="product-badge"
                          [style.padding-left.rem]="0.25"
                          [style.padding-top.rem]="0.25"
                          [style.padding-right.rem]="0.25"
                          [style.display]="'inline'"
                          [style.height.px]="viewModel.badgesInlineWithTitleHeight$ | async"
                          [asset]="variantBadge?.image"
                          alt="badge"
                          src="" />
                      }
                    </span>
                  }
                </div>
                <div class="product-brand-and-label">
                  <div class="product-brand" [style.color]="viewModel.bodyTextColor$ | async">
                    {{ data | method: 'getBrand' }}
                  </div>
                  @if ((viewModel.hasLabel$ | async) && !(viewModel.isAccessory$ | async)) {
                    <div class="label">
                      <app-label-inflator
                        *ngIf="viewModel.hasLabel$ | async"
                        class="print-card-label"
                        [columnLabel]="false"
                        [labelComponentInterface]="data"
                        [reset]="false">
                      </app-label-inflator>
                    </div>
                  }
                </div>
              </div>
              <div *ngIf="viewModel.topTerpene$ | async" class="top-terpene">
                <div class="label">Top Terpene</div>
                <div class="value">
                  {{ viewModel.topTerpene$ | async }}
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="(viewModel.hasBadges$ | async) || (data | getVariantAssetForCard | async)"
            class="brand-logo-and-badges">
            <div>
              <img
                *ngIf="data | getVariantAssetForCard | async as variantAsset"
                appImage
                class="brand-logo"
                [asset]="variantAsset"
                src=""
                alt="" />
            </div>

            @if ((viewModel.hasRegularBadges$ | async) && !(viewModel.isAccessory$ | async)) {
              <div class="badges">
                @for (variantBadge of viewModel.regularBadges$ | async; track variantBadge.id) {
                  <img appImage class="product-badge" [asset]="variantBadge?.image" alt="badge" src="" />
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="card-information-table">
      @if (!(viewModel.isAccessory$ | async)) {
        <div class="table-data">
          <div class="table-row table-header">
            <div
              class="property-container"
              [style.padding-left.px]="viewModel.propertyContainerLeftPaddingInPx$ | async">
              <ng-container *ngFor="let property of viewModel.filteredPoolingCompounds$ | async">
                <div
                  class="table-cell table-header-cell"
                  appPrintCardScaleDownText
                  [maxHeightInPx]="14"
                  [maxWidthInPx]="viewModel.maxWidthForPropertyScaleDownInPx$ | async"
                  [adjustLineHeight]="false"
                  [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
                  {{ property.title }}
                </div>
              </ng-container>
            </div>
            <div class="non-property-container">
              <div *ngIf="viewModel.showSize$ | async" class="table-cell table-header-cell non-property-cell">SIZE</div>
              <div
                *ngIf="viewModel.atLeastOneGridVariantOnSale$ | async"
                class="table-cell table-header-cell non-property-cell">
                REGULAR
              </div>
              <div class="table-cell table-header-cell non-property-cell">$</div>
            </div>
          </div>
          <div class="table-row table-body">
            <div
              class="property-container"
              [style.padding-left.px]="viewModel.propertyContainerLeftPaddingInPx$ | async">
              <ng-container *ngFor="let property of viewModel.filteredPoolingCompounds$ | async">
                <div
                  class="table-cell table-body-cell"
                  appPrintCardScaleDownText
                  [maxHeightInPx]="16"
                  [maxWidthInPx]="viewModel.maxWidthForPropertyScaleDownInPx$ | async"
                  [adjustLineHeight]="false"
                  [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
                  {{ property.value }}
                </div>
              </ng-container>
            </div>

            <div class="non-property-container">
              <div
                *ngIf="(viewModel.showSize$ | async) && (data | method: 'getSize') as size"
                class="table-cell table-body-cell non-property-cell">
                {{ size }}
              </div>
              <div
                *ngIf="viewModel.atLeastOneGridVariantOnSale$ | async"
                class="table-cell table-body-cell non-property-cell card-regular-price">
                <app-column-primary-price
                  [menu]="viewModel.cardStackMenu$ | async"
                  [section]="viewModel.cardStack$ | async"
                  [colVm]="viewModel.spoofedColViewModel$ | async"
                  [rowVm]="viewModel.cardData$ | async"
                  [locConfig]="viewModel.locationConfig$ | async"
                  [locationId]="viewModel.locationId$ | async"
                  [productStylingVm]="viewModel">
                </app-column-primary-price>
              </div>
              <div class="table-cell table-body-cell non-property-cell">
                <app-column-primary-price
                  [menu]="viewModel.cardStackMenu$ | async"
                  [section]="viewModel.cardStack$ | async"
                  [colVm]="viewModel.spoofedColViewModel$ | async"
                  [rowVm]="viewModel.cardData$ | async"
                  [hidePreviousPrice]="true"
                  [locConfig]="viewModel.locationConfig$ | async"
                  [locationId]="viewModel.locationId$ | async"
                  [productStylingVm]="viewModel">
                </app-column-primary-price>
              </div>
            </div>
          </div>
        </div>
      }
      @if (viewModel.isAccessory$ | async) {
        <div class="accessory-price">
          <app-column-primary-price
            [menu]="viewModel.cardStackMenu$ | async"
            [section]="viewModel.cardStack$ | async"
            [colVm]="viewModel.spoofedColViewModel$ | async"
            [rowVm]="viewModel.cardData$ | async"
            [locConfig]="viewModel.locationConfig$ | async"
            [locationId]="viewModel.locationId$ | async"
            [productStylingVm]="viewModel">
          </app-column-primary-price>
        </div>
      }
    </div>
  </div>
</div>
